export const LinkStyles = (props) => {
  return {
    color: props.hovered ? 'grey' : '#319bd5',
    textDecoration: 'none'
  };
};